import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import validate from 'validate.js'
import DatePicker from 'react-datepicker'

import config from '@/config/config-esm'
import { validateFamilyPackages } from '@/lib/family_validation'

import { setFormData } from '@/store/slices/formDataSlice'
import { getFamilySubscriptionTotalPrice } from '@/lib/prices'
import SpecialCampaign from '@/components/SpecialCampaign'

const FamilyStep1Component = ({ onClose }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const formData = useSelector((state) => state.formData)
  const appData = useSelector((state) => state.appData)
  const layout = useSelector((state) => state.layout)

  const allowNext = () => {
    return validateFamilyPackages(formData.family)
  }

  const getTypeCount = (type) => {
    const family = formData.family || {}
    const counts = family.counts || {}
    return counts[type] || 0
  }

  const getTotalCount = () => {
    const family = formData.family || {}
    const counts = family.counts || {}
    return (counts.adult || 0) + (counts.child || 0)
  }

  const nextStep = () => {
    dispatch(setFormData({ familyStep: 'owner' }))
  }

  const close = () => {
    dispatch(setFormData({ newFamilyPhoneSession: false }))
    onClose()
  }

  const changeCount = (type, action) => {
    const members = [...formData.family.members]
    let count = formData.family.counts[type]

    if (action === 'add') {
      count++
      members.push({
        type: type,
        set: false,
        id: Math.random().toString(),
        subscription: true,
      })
    } else {
      const unsetIdx = members.findIndex((m) => m.type === type && !m.owner && !m.set)
      const idx = unsetIdx !== -1 ? unsetIdx : members.findIndex((m) => m.type === type && !m.owner)

      if (idx !== -1) {
        count--
        members.splice(idx, 1)
      }
    }

    dispatch(
      setFormData({
        family: {
          ...formData.family,
          counts: {
            ...formData.family.counts,
            [type]: count,
          },
          members,
        },
      }),
    )
  }

  const pricePerPerson = () => {
    const pkg = formData.family.selectedPackageId
      ? appData.familyDataPackages.filter((p) => p.id === formData.family.selectedPackageId)[0]
      : null

    return pkg
      ? parseInt(getFamilySubscriptionTotalPrice(formData.family, pkg) / getTotalCount())
      : 0
  }

  const { departmentId } = layout.data

  return (
    <div>
      <h1>Hvor mange skal ha abonnement?</h1>
      <p>Minimum to personer.</p>
      <div className="familyMemberCounts">
        {/*
          <div className="childrenCount counts">
            <h2>Barn</h2>
            <p className="ageDescription">under 18</p>
            <div className="countSelectors">
              <div className={`minus${(getTypeCount('child') <= 0 ? ' disabled' : '')}`} onClick={() => changeCount('child', 'subtract')}>-</div>
              <div className="count">{getTypeCount('child')}</div>
              <div className="plus" onClick={() => changeCount('child', 'add')}>+</div>
            </div>
          </div>
          */}
        <div className="adultCount counts">
          <h2>Antall medlemmer</h2>
          {/* <p className="ageDescription">over 18</p> */}
          <div className="countSelectors">
            <div
              className={`minus${getTypeCount('adult') <= 0 ? ' disabled' : ''}`}
              onClick={() => changeCount('adult', 'subtract')}
            >
              -
            </div>
            <div className="count">{getTypeCount('adult')}</div>
            <div className="plus" onClick={() => changeCount('adult', 'add')}>
              +
            </div>
          </div>
          {(true || config.chatDepartmentIds.includes(departmentId)) && (
            <div className="includeExtraData" style={{ marginTop: '4rem' }}>
              <div className="input_wrapper">
                <input
                  type="checkbox"
                  id="include-extra-data"
                  onChange={(ev) =>
                    dispatch(
                      setFormData({
                        family: { ...formData.family, includeExtraData: ev.target.checked },
                      }),
                    )
                  }
                />
                <label htmlFor="include-extra-data">
                  <span>Inkluder ekstra data?</span>
                </label>
              </div>
            </div>
          )}
          <div className="includeTenPercentOff">
            <div className="input_wrapper">
              {/*<input
                  type="checkbox"
                  id="include-ten-percent-off"
                  onChange={(ev) =>
                    dispatch(
                      setFormData({
                        family: { ...formData.family, includeTenPercentOff: ev.target.checked },
                      }),
                    )
                  }
                />
                <label htmlFor="include-ten-percent-off">
                  <span>Inkluder 10% rabatt?</span>
                </label>*/}
              <input
                type="checkbox"
                id="include-twenty-percent-off"
                onChange={(ev) =>
                  dispatch(
                    setFormData({
                      family: { ...formData.family, includeTwentyPercentOff: ev.target.checked },
                    }),
                  )
                }
              />
              <label htmlFor="include-twenty-percent-off">
                <span>Inkluder 20% rabatt?</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <h1>Velg felles data</h1>
      <div className="dataPriceBoxes">
        {_.sortBy(appData.familyDataPackages, (p) =>
          parseInt(p.bot_key.replace(/[^\d]+/g, '')),
        ).map((pkg) => {
          const classNames =
            formData.family.selectedPackageId === pkg.id ? 'dataPriceBox selected' : 'dataPriceBox'
          const packagePrice = getFamilySubscriptionTotalPrice(formData.family, pkg)
          const gbStr =
            pkg.name === 'Familie Ubegrenset'
              ? 'Ubegrenset'
              : !config.chatDepartmentIds.includes(departmentId) ||
                  (config.chatDepartmentIds.includes(departmentId) &&
                    formData.family.includeExtraData) // config.chatDepartmentIds.includes(departmentId)
                ? pkg.name.replace(/^[a-zA-Z -]+/, '')
                : `${parseInt(pkg.bot_key.replace(/[^0-9]/g, ''))} GB`
          return (
            <div
              key={`pkg-${pkg.id}`}
              className={classNames}
              onClick={() =>
                dispatch(setFormData({ family: { ...formData.family, selectedPackageId: pkg.id } }))
              }
            >
              <div className="dataAmount">{gbStr}</div>
              <div className="dataPrice">{packagePrice} kr</div>
              <div className="dataDescription">
                /mnd
                <br />
                {getTotalCount()} pers.
              </div>
            </div>
          )
        })}
      </div>
      {formData.family.selectedPackageId && getTotalCount() >= 2 && (
        <p>Pris per person: kr {pricePerPerson()}/mnd</p>
      )}
      {false && formData.family && formData.family.selectedPackageId && <SpecialCampaign />}
      <div className="buttons">
        <button className="cancel" onClick={close}>
          Lukk
        </button>
        <button className="continue" disabled={!allowNext()} onClick={nextStep}>
          Fortsett
        </button>
      </div>
    </div>
  )
}

export default FamilyStep1Component
